import React from 'react';
import { MapPin, Package, Star } from 'lucide-react';
import {
 buildBrandCssVars,
 getBrandButtonStyle,
 getBrandCtaLabel,
 isBrandActive,
} from '../../../utils/vendorBranding';

const VendorBrandPreview = ({ businessName, brand, profileImageUrl, city, state, minPrice = 299 }) => {
 const active = isBrandActive(brand);
 const cssVars = buildBrandCssVars(brand);
 const primaryBtnStyle = getBrandButtonStyle(brand, 'primary');
 const ctaLabel = getBrandCtaLabel(brand, 'View Services');
 const showBanner = active && brand.hero_style === 'banner';
 const logoUrl = active && brand.show_logo_in_header !== false ? brand.logo_url : null;

 return (
 <div
 className="rounded-md border border-border overflow-hidden bg-surface shadow-sm"
 style={cssVars}
 >
 <div className="px-3 py-2 bg-surface-muted border-b border-gray-200 flex items-center justify-between">
 <span className="text-xs font-medium text-gray-500 uppercase tracking-wide">Live preview</span>
 <span className="text-xs text-gray-400">Public profile</span>
 </div>

 <div className="p-4 space-y-4 bg-surface scale-[0.98] origin-top">
 {showBanner && (
 <div
 className="relative h-24 sm:h-28 rounded-lg overflow-hidden"
 style={
 brand.cover_image_url
 ? undefined
 : { background: `linear-gradient(135deg, ${brand.primary_color}, ${brand.accent_color})` }
 }
 >
 {brand.cover_image_url && (
 <img
 src={brand.cover_image_url}
 alt=""
 className="w-full h-full object-cover"
 />
 )}
 <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
 <div className="absolute bottom-3 left-3 flex items-center gap-2">
 {logoUrl && (
 <img src={logoUrl} alt="" className="w-8 h-8 rounded-full object-cover border-2 border-white" />
 )}
 <span className="text-white text-sm font-medium truncate max-w-[180px]">
 {businessName || 'Your Business'}
 </span>
 </div>
 </div>
 )}

 <div className="flex items-start justify-between gap-3">
 <div className="flex items-start gap-3 min-w-0">
 {!showBanner && logoUrl && (
 <img
 src={logoUrl}
 alt=""
 className="w-8 h-8 rounded-lg object-cover border border-gray-200 flex-shrink-0"
 />
 )}
 <div className="min-w-0">
 {!showBanner && (
 <h3 className="text-base font-light text-gray-900 truncate">
 {businessName || 'Your Business'}
 </h3>
 )}
 {brand?.tagline && (
 <p className="text-xs text-gray-600 mt-0.5 line-clamp-2">{brand.tagline}</p>
 )}
 {(city || state) && (
 <p className="text-xs text-gray-500 mt-1 inline-flex items-center gap-1">
 <MapPin className="w-3 h-3" />
 {[city, state].filter(Boolean).join(', ')}
 </p>
 )}
 </div>
 </div>
 </div>

 <div className="h-20 rounded-lg bg-gray-100 border border-gray-200 flex items-center justify-center text-xs text-gray-400">
 Portfolio gallery
 </div>

 <div className="rounded-md border border-border p-4 shadow-sm">
 <div className="flex items-baseline gap-1 mb-3">
 <span className="text-lg font-light text-gray-900">${minPrice.toFixed(2)}</span>
 <span className="text-xs text-gray-500">starting price</span>
 </div>

 <div className="mb-3 p-3 border border-gray-200 rounded-lg">
 <div className="flex items-center justify-between text-xs">
 <span className="text-gray-500">Services</span>
 <span className="inline-flex items-center gap-1 text-gray-900">
 <Package className="w-3 h-3" />
 3 available
 </span>
 </div>
 </div>

 <div
 className={`w-full py-2.5 text-center rounded-lg text-sm font-light mb-2 ${ active ? '' : 'bg-black text-white' }`}
 style={active ? primaryBtnStyle : undefined}
 >
 {ctaLabel}
 </div>

 <div className="flex items-center justify-between text-xs pt-2 border-t border-gray-100">
 <span className="text-gray-500">Rating</span>
 <span className="inline-flex items-center gap-1 text-gray-900">
 <Star className="w-3 h-3 fill-yellow-400 text-yellow-400" />
 4.9
 </span>
 </div>
 </div>
 </div>
 </div>
 );
};

export default VendorBrandPreview;
